/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import * as b64$ from "../lib/base64.js";
import { ClosedEnum } from "../types/enums.js";

/**
 * 指定响应内容的格式。可选值为 `image`, `json`, `json_url`。
 */
export const GetImageQrcodeFormat = {
  Image: "image",
  Json: "json",
  JsonUrl: "json_url",
} as const;
/**
 * 指定响应内容的格式。可选值为 `image`, `json`, `json_url`。
 */
export type GetImageQrcodeFormat = ClosedEnum<typeof GetImageQrcodeFormat>;

export const GetImageQrcodeFormat$zodSchema = z.enum([
  "image",
  "json",
  "json_url",
]).describe("指定响应内容的格式。可选值为 `image`, `json`, `json_url`。");

export type GetImageQrcodeRequest = {
  text: string;
  size?: number | undefined;
  format?: GetImageQrcodeFormat | undefined;
  transparent?: boolean | undefined;
  fgcolor?: string | undefined;
  bgcolor?: string | undefined;
};

export const GetImageQrcodeRequest$zodSchema: z.ZodType<GetImageQrcodeRequest> =
  z.object({
    bgcolor: z.string().default("#FFFFFF").describe(
      "二维码背景色，使用十六进制格式。当 `transparent=true` 时此参数会被忽略。URL 中需要将 `#` 编码为 `%23`。",
    ),
    fgcolor: z.string().default("#000000").describe(
      "二维码前景色（即二维码本身的颜色），使用十六进制格式。URL 中需要将 `#` 编码为 `%23`。",
    ),
    format: GetImageQrcodeFormat$zodSchema.default("image"),
    size: z.int().default(256).describe(
      "二维码图片的边长（正方形），单位是像素。有效范围是 256 到 2048 之间。",
    ),
    text: z.string().describe(
      "你希望编码到二维码中的任何文本内容，比如一个URL、一段话或者一个JSON字符串。",
    ),
    transparent: z.boolean().default(false).describe(
      "是否使用透明背景。启用后生成的 PNG 图片将具有 alpha 通道，背景透明。",
    ),
  });

export type GetImageQrcodeInternalServerErrorDetails = {};

export const GetImageQrcodeInternalServerErrorDetails$zodSchema: z.ZodType<
  GetImageQrcodeInternalServerErrorDetails
> = z.object({});

/**
 * 服务器内部错误。在生成二维码的过程中发生了未知错误。
 */
export type GetImageQrcodeInternalServerErrorResponseBody = {
  code?: string | undefined;
  details?: GetImageQrcodeInternalServerErrorDetails | undefined;
  message?: string | undefined;
};

export const GetImageQrcodeInternalServerErrorResponseBody$zodSchema: z.ZodType<
  GetImageQrcodeInternalServerErrorResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => GetImageQrcodeInternalServerErrorDetails$zodSchema)
    .optional(),
  message: z.string().optional(),
}).describe("服务器内部错误。在生成二维码的过程中发生了未知错误。");

export type GetImageQrcodeBadRequestDetails = {};

export const GetImageQrcodeBadRequestDetails$zodSchema: z.ZodType<
  GetImageQrcodeBadRequestDetails
> = z.object({});

/**
 * 请求参数错误。请检查 `text` 是否提供，`size` 是否在有效范围内，`format` 是否为支持的值。
 */
export type GetImageQrcodeBadRequestResponseBody = {
  code?: string | undefined;
  details?: GetImageQrcodeBadRequestDetails | undefined;
  message?: string | undefined;
};

export const GetImageQrcodeBadRequestResponseBody$zodSchema: z.ZodType<
  GetImageQrcodeBadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => GetImageQrcodeBadRequestDetails$zodSchema).optional(),
  message: z.string().optional(),
}).describe(
  "请求参数错误。请检查 `text` 是否提供，`size` 是否在有效范围内，`format` 是否为支持的值。",
);

/**
 * 请求成功。响应的格式和内容取决于你传入的 `format` 参数。请参考下面不同 `Content-Type` 的定义。
 */
export type GetImageQrcodeResponseBody = { url?: string | undefined };

export const GetImageQrcodeResponseBody$zodSchema: z.ZodType<
  GetImageQrcodeResponseBody
> = z.object({
  url: z.string().optional(),
}).describe(
  "请求成功。响应的格式和内容取决于你传入的 `format` 参数。请参考下面不同 `Content-Type` 的定义。",
);

export type GetImageQrcodeResponse =
  | Uint8Array
  | string
  | GetImageQrcodeResponseBody
  | GetImageQrcodeBadRequestResponseBody
  | GetImageQrcodeInternalServerErrorResponseBody;

export const GetImageQrcodeResponse$zodSchema: z.ZodType<
  GetImageQrcodeResponse
> = z.union([
  z.string().describe("Base64-encoded binary content").transform(
    b64$.bytesFromBase64,
  ),
  z.lazy(() => GetImageQrcodeResponseBody$zodSchema),
  z.lazy(() => GetImageQrcodeBadRequestResponseBody$zodSchema),
  z.lazy(() => GetImageQrcodeInternalServerErrorResponseBody$zodSchema),
]);
